import { useHeaders } from "hooks/api/useHeaders";
import { useMutation } from "react-query";
import { submitAssetReq } from "api/assets";

export const useSubmitAsset = () => {
    const headers = useHeaders();

    return useMutation(({ materialSpecId, complete }: { materialSpecId: number; complete?: boolean }) =>
        submitAssetReq(headers, materialSpecId, complete)
    );
};
